import type { TelemetryPort } from '@/domain/telemetry/TelemetryPort'
import type { TelemetryEvent } from '@/domain/telemetry/types'

/**
 * Drops every event. The Local MVP default — until Phase 5 wires the
 * consent-gated transport (ADR-024, tech-spec §12.3), no telemetry
 * leaves the browser.
 *
 * Do not log here. A `console.log` would defeat the privacy posture
 * by leaking event props to anything tailing the console.
 */
export class NoopTelemetryAdapter implements TelemetryPort {
  emit(_event: TelemetryEvent): void {
    void _event
  }
}
